import classNames from "classnames"

import bgPng from "../../../assets/img/pv/ticket/bg.png"
import bgWebP from "../../../assets/img/pv/ticket/bg.webp"
import innerBgPng from "../../../assets/img/pv/ticket/inner-bg.png"
import innerBgWebP from "../../../assets/img/pv/ticket/inner-bg.webp"
import styles from "./index.module.less"

interface TicketBaseProps {
    index?: number
    className?: string
    style?: React.CSSProperties
}

const TicketBase: React.FC<TicketBaseProps> = (props) => {
    const { index = 1, className, style } = props

    return (
        <div className={classNames(styles.ticketBase, className)} style={style}>
            <picture>
                <source srcSet={bgWebP} type="image/webp" />
                <img src={bgPng} alt="bg" />
            </picture>
            <div className={styles.center}>
                <picture>
                    <source srcSet={innerBgWebP} type="image/webp" />
                    <img src={innerBgPng} alt="inner-bg" />
                </picture>
                <div className={styles.cover} data-index={index} />
            </div>
            <div className={styles.noise} />
        </div>
    )
}

interface TicketProps extends TicketBaseProps {
    active?: boolean
    onClick?: () => void
}

const Ticket: React.FC<TicketProps> = (props) => {
    const { index = 1, active = false, className, style, onClick } = props

    return (
        <div
            className={classNames(
                styles.ticket,
                active && styles.active,
                className
            )}
            style={style}
            onClick={onClick}
        >
            <TicketBase index={index} />
            <TicketBase index={index} className={styles.original} />
            <div className={styles.border}>
                <div className={styles.inner} />
            </div>
        </div>
    )
}

export default Ticket
